import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { LocalStorageService } from '../services/local-storage.service';
import * as webPlayer from '../actions/web-player';

@Injectable()
export class WebPlayerEffects {
  redirectUrl = 'goarmyedge.com/webplayer';

  selectSport$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(webPlayer.ToggleWebPlayerSportAction),
        map((action) => action.payload),
        tap((sport) => this.storage.set({ sport })),
        tap((sport) => window.open(`//${sport}.${this.redirectUrl}`))
      ),
    { dispatch: false }
  );

  redirectWebPlayer$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(webPlayer.RedirectWebPlayerAction),
        map((action) => action.payload),
        tap((sport) => window.open(`//${sport}.${this.redirectUrl}`))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private storage: LocalStorageService
  ) {}
}
